module.exports = __webpack_public_path__ + "media/images/right_arrow-c6e7210671a759e72f2cfd13240ffe72.png";